// Human-friendly display mask for PSTN caller numbers: +1 NANP numbers
// render as "(925) 400-0700"; anything else (other country codes, short
// codes, malformed) passes through unchanged. Keep in sync with the server
// copy in apps/server/src/lib/telephony/sip/identity.ts.
export function formatPhoneDisplay(e164: string): string {
  const m = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(e164)
  return m ? `(${m[1]}) ${m[2]}-${m[3]}` : e164
}
